import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {OppgaveTjenesteWeb} from "web/moduler/oppgave/OppgaveTjenesteWeb";
import {RedigerOppgaveDialog} from "web/moduler/oppgave/modale/redigerOppgaveDialog/redigerOppgaveDialog";
import {OppgaveTjeneste} from "felles/tjenester/modulspesifikke/OppgaveTjeneste";
import {OppgaveModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {kopierFraAjsTilNg2} from "felles-ng2/modell/ajsNg2ModellBroer";
import {KommentarDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

const css = require('./visOppgaveDialog.scss');

export function registrerVisOppgaveDialog(angular: IModule) {
    angular
        .service(VisOppgaveDialog.regNavn, VisOppgaveDialog.forInjisering())
        .controller(VisOppgaveDialogKontroller.regNavn, VisOppgaveDialogKontroller.forInjisering());
}

export class VisOppgaveDialog {
    static regNavn = "wm.oppgave.modale.visOppgaveDialog.VisOppgaveDialog";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            VisOppgaveDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./visOppgaveDialog.html'),
        controller: VisOppgaveDialogKontroller.regNavn,
        controllerAs: 'ktr',
        bindToController: true
    };

    visVisOppgaveDialog(oppgave: l.OppgaveModell) {
        this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {oppgave: oppgave}}));
    }
}

export class VisOppgaveDialogKontroller implements IController{
    static regNavn = "wm.oppgave.modale.visOppgaveDialog.VisOppgaveDialogKontroller";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            RedigerOppgaveDialog.regNavn,
            OppgaveTjeneste.regNavn,
            OppgaveTjenesteWeb.regNavn,
            ng2RegNavn.KommentarDatatjenesteForAjs,
            VisOppgaveDialogKontroller
        ]
    }


    constructor(private $mdDialog: angular.material.IDialogService,
                private redigerOppgaveDialog: RedigerOppgaveDialog,
                private oppgaveTjeneste: OppgaveTjeneste,
                private oppgaveTjenesteWeb: OppgaveTjenesteWeb,
                private kommentarDatatjeneste: KommentarDatatjenesteForAjs) {
    }

    oppgave: l.OppgaveModell; //satt via locals.oppgave i dialogKonfigurasjon

    ng2Oppgave: OppgaveModell;
    redigeringMulig = false;


    lukk() {
        this.lukkDialog();
    }

    rediger() {
        this.lukkDialog();
        this.redigerOppgaveDialog.visRedigerOppgaveDialog(this.oppgave);
    }

    slett() {
        this.oppgaveTjenesteWeb.slett(this.oppgave);
        this.lukkDialog();
    }

    $onInit() {
        this.redigeringMulig = this.oppgaveTjeneste.kanOppgaveRedigeres(this.oppgave);
        this.ng2Oppgave = kopierFraAjsTilNg2(this.oppgave);
        //populer KommentarerDatatjeneste (for at <kommentarer-teller> og <oppgave-kommentarer> skal ha tilgang til data)
        this.kommentarDatatjeneste.tjeneste().then(kommentarerDatatjeneste =>
            kommentarerDatatjeneste.erstattILokallager(this.ng2Oppgave.kommentarer, this.ng2Oppgave.id));
    }

    //hjelpemetoder

    private lukkDialog() {
        this.$mdDialog.hide();
    }

}
